var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0018 45.2452C35.5975 45.2452 45.8083 35.1167 45.8083 22.6226C45.8083 10.1285 35.5975 0 23.0018 0C10.4061 0 0.195312 10.1285 0.195312 22.6226C0.195312 35.1167 10.4061 45.2452 23.0018 45.2452Z",
    fill: "#17B26A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4919 33.0641C19.0267 33.064 18.5805 32.8806 18.2516 32.5542L12.9886 27.3336C12.669 27.0054 12.4922 26.5658 12.4962 26.1095C12.5002 25.6533 12.6847 25.2168 13.0099 24.8942C13.3352 24.5715 13.7752 24.3885 14.2352 24.3845C14.6952 24.3806 15.1383 24.556 15.4692 24.873L19.2533 28.6266L30.3355 12.9247C30.4643 12.7299 30.6312 12.5628 30.8263 12.4331C31.0214 12.3035 31.2408 12.214 31.4714 12.17C31.702 12.126 31.9391 12.1284 32.1688 12.177C32.3985 12.2256 32.616 12.3195 32.8084 12.453C33.0008 12.5865 33.1643 12.757 33.289 12.9544C33.4138 13.1517 33.4973 13.3719 33.5347 13.6019C33.5721 13.8319 33.5625 14.067 33.5066 14.2932C33.4507 14.5195 33.3495 14.7323 33.2092 14.919L20.9287 32.321C20.7819 32.5293 20.5908 32.7031 20.3689 32.8303C20.1471 32.9575 19.8998 33.0349 19.6446 33.0571C19.5938 33.062 19.5429 33.0644 19.4919 33.0641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormSuccessIcon);
export default __webpack_public_path__ + "static/media/form_success_icon.20819ad5febc724a14a87ca3049fa75d.svg";
export { ForwardRef as ReactComponent };